import { render, staticRenderFns } from "./img_edit.vue?vue&type=template&id=10bf7501&scoped=true&"
import script from "./img_edit.vue?vue&type=script&lang=js&"
export * from "./img_edit.vue?vue&type=script&lang=js&"
import style0 from "./img_edit.vue?vue&type=style&index=0&id=10bf7501&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bf7501",
  null
  
)

export default component.exports